import React from 'react';
import * as T from 'prop-types';
import AutoIntl from '@au/core/lib/components/elements/AutoIntl';
import AuToggle, { TOGGLE_SIZE_SMALL } from '@au/core/lib/components/elements/AuToggle';
import styles from '../../../css/components/search_section.module.scss';

export const OrDivider = () => (
  <div className={styles.or_divider}>
    <hr className={styles.or_divider_line} />
    <AutoIntl displayId="au.vehicles.or" tag="span" className={styles.or_divider_text} />
    <hr className={styles.or_divider_line} />
  </div>
);

export const SearchSummary = ({children, collapsed, toggleName, onToggle, clearLabel, onClear}) => (
  <div className={styles.search_summary}>
    <span className={styles.search_summary_pill}>
      {children}
      {onClear && (
        <button
          type="button"
          className={styles.search_summary_clear}
          onClick={onClear}
          aria-label={clearLabel}
          title={clearLabel}
            />
        )}
    </span>
    <div className={styles.search_toggle}>
      <AutoIntl
        displayId="au.vehicles.search.options"
        tag="span"
        className={styles.search_toggle_caption}
            />
      <AuToggle
        // AuToggle is uncontrolled (defaultChecked); remount so it reflects programmatic collapse/expand
        key={collapsed ? 'collapsed' : 'expanded'}
        name={toggleName}
        size={TOGGLE_SIZE_SMALL}
        checked={!collapsed}
        onChange={onToggle}
            />
    </div>
  </div>
);

SearchSummary.propTypes = {
    children: T.node.isRequired,
    collapsed: T.bool.isRequired,
    toggleName: T.string.isRequired,
    onToggle: T.func.isRequired,
    onClear: T.func,
    clearLabel: T.string
};
